import dynamicImageImporter from '../../utils/dynamicImageImporter.js';
import './NavigationBar.css';

const staticImages = dynamicImageImporter(require.context('/public/art/static', false));

function NavigationBar(){
    return (
        <div className='NavigationBar'>
            <img src={staticImages['honey']} className='NavigationBar-honey' alt='DrippingHoney'/>
            <img src={staticImages['logo']} className='NavigationBar-logo' alt='Logo'/>
        </div>
    );
}

export default NavigationBar;